import React, { Component } from "react";

import { downloadReport } from "api/report";
import DownloadIcon from "assets/SvgIcon/DownloadIcon";
import DupontIconButton from "components/DupontIconButton";
import { REPORT_HISTORY_TABLE_STRINGS } from "constants/constantStrings";

export default class ReportDownloadRenderer extends Component {
  constructor(props) {
    super(props);
    this.downloadReportHandler = this.downloadReportHandler.bind(this);
  }

  downloadReportHandler = async () => {
    try {
      const reportID = this.props.node.data.FileID;
      const response = await downloadReport(reportID);
      if (response?.data?.url) {
        window.open(response.data.url);
      }
    } catch (err) {}
  };

  render() {
    return (
      <span className="download__icon--width">
        <DupontIconButton tooltip={REPORT_HISTORY_TABLE_STRINGS.downloadReport} onClick={this.downloadReportHandler}>
          <DownloadIcon />
        </DupontIconButton>
      </span>
    );
  }
}
